import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import ErrorBoundary from "@/components/ErrorBoundary";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Problem from "@/components/Problem";
import Deliverables from "@/components/Deliverables";
import Process from "@/components/Process";
import WhoItsFor from "@/components/WhoItsFor";
import Pricing from "@/components/Pricing";
import Faq from "@/components/Faq";
import FinalCta from "@/components/FinalCta";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = undefined;
    };
  }, []);

  return (
    <ErrorBoundary>
      <div id="top" className="bg-cream font-sans text-ink antialiased">
        <div className="grain" aria-hidden="true" />
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <Problem />
          <Deliverables />
          <Process />
          <WhoItsFor />
          <Pricing />
          <Faq />
          <FinalCta />
        </main>
        <Footer />
      </div>
    </ErrorBoundary>
  );
}

export default App;
